import { React, useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Link, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { loadUserData  } from "../../User_Data.js";

import {
  Card,
  Col,
  Row,
  Typography,
} from "antd";

import {
  DashboardOutlined,
  EditOutlined,
  FileSearchOutlined,
} from '@ant-design/icons';

import Echart from "./EChart.js";
import LineChart from "./LineChart.js";
import DoughnutChart from "./DoughnutChart.js";
import ScrollableTable from "./TableSummary.js";
import Sidebar from "../../Side_Bar/Customer_Side_Bar.js";

const App = () =>{
  const location = useLocation();
  const [userData, setUserData] = useState(loadUserData());


  const { Title, Text } = Typography;
  const [loading, setIsLoading] = useState(true);
  const mainUrl                       = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";

  // const contractOptions = ["Blue Ice", "Far Tech", "IBPO"];
  const [contractOptions, setContractOptions] = useState([]);
  const [contractIds, setContractIds] = useState([]);
  const [selectedContract, setSelectedContract] = useState('');
  const [id, setId] = useState(null);

  const fetchContractData = async () => {
    try {
      const response = await fetch(`${mainUrl}/getAllTable?tableName=Contract`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    } catch (error) {
      console.error('Error fetching table data:', error);
      throw error; // Re-throw the error for the calling function to handle
    }
  };
  
  // Simulated fetch of customer data
  useEffect(() => {
    const fetchData = async () => {
      try {

        const contract_list = await fetchContractData();

        const contracts = contract_list.map(contract => ({
          id: contract.contract_id,
          name: contract.name,
        }));
        
        setContractIds(contracts)
        setId(contracts[0].id)
        setSelectedContract(contracts[0].name)
        setContractOptions(contracts.map(contract => contract.name));


      } catch (error) {
        // Handle error, e.g., show an error message to the user
        console.error('Error fetching data:', error);
      } finally {
      }
    };

    fetchData();
  }, []);


  const [data, setData] = useState([]);
  const [unique_num, setUniqueNum] = useState([]);
  const [unique_sess, setUniqueSess] = useState([]);
  const [contract_data, setContractData] = useState([]);
  const [customer_pricing_data, setCustomerPricing] = useState([]);
  const [company_pricing_data, setCompanyPricing] = useState([]);


  useEffect(() => {
    const fetchData = async (url, setDataFunction) => {
      try {
        const response = await fetch(url);
        const data = await response.json();
        setDataFunction(data);
      } catch (error) {
        console.error(`Error fetching data from ${url}:`, error);
        // Handle error appropriately
      }
    };

    if (id !== null) {
      const messagesUrl = `${mainUrl}/getTable?tableName=Message&contract_id=${id}`;
      const uniqueNumbersUrl = `${mainUrl}/getUniqueNumbersMonthly?contract_id=${id}`;
      const uniqueSessionsUrl = `${mainUrl}/getUniqueSessionsMonthly?contract_id=${id}`;
      const contractUrl = `${mainUrl}/getTable?tableName=Contract&contract_id=${id}`;
      const CustomerPricingRateUrl = `${mainUrl}/getTable?tableName=Customer_Pricing&contract_id=${id}`;
      const CompanyPricingRateUrl = `${mainUrl}/getTable?tableName=Company_Pricing&contract_id=${id}`;

      Promise.all([
        fetchData(messagesUrl, setData),
        fetchData(uniqueNumbersUrl, setUniqueNum),
        fetchData(uniqueSessionsUrl, setUniqueSess),
        fetchData(contractUrl, setContractData),
        fetchData(CustomerPricingRateUrl, setCustomerPricing),
        fetchData(CompanyPricingRateUrl, setCompanyPricing),
      ])
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [id]);
  


  let total_messages            = 0;
  let average_media_per_message = 0;
  let total_cost                = 0;
  let average_cost              = 0;
  let average_messages          = 0;
  let no_users                  = 0;
  
  const cost_map = new Map();
  const no_messages = new Map();
  const users_map = new Map();
  const sessions_map = new Map();
  const unique_users_map = new Map();

  for (let i = 0; i<unique_sess.length; i++){
    sessions_map.set(unique_sess.at(i).month, unique_sess.at(i).num_sessions);
  }

  for (let i = 0; i<unique_num.length; i++){
    unique_users_map.set(unique_num.at(i).month, unique_num.at(i).unique_acc_from_count);
  }

  for(let i =0; i<data.length; i++){
    const year = data.at(i).date_sent.split("T")[0].split("-")[0];
    const month = data.at(i).date_sent.split("T")[0].split("-")[1];

    if(cost_map.get(year + "-" + month) == undefined){
      cost_map.set(year + "-" + month, data.at(i).company_cost);
    }else{
      cost_map.set(year + "-" + month , cost_map.get(year + "-" + month) + data.at(i).company_cost);
    }

    if(no_messages.get(year + "-" + month) == undefined){
      no_messages.set(year + "-" + month, 1);
    }else{
      no_messages.set(year + "-" + month, no_messages.get(year + "-" + month) + 1);
    }

    if(users_map.get(data.at(i).acc_from) == undefined){
      users_map.set(data.at(i).acc_from, 1);
    }else{
      users_map.set(data.at(i).acc_from, users_map.get(data.at(i).acc_from) + 1);
    }
    
    average_media_per_message += data.at(i).num_media;
    total_cost += data.at(i).company_cost;
  }
  
  cost_map.forEach((value, key) => {
    average_cost += value;
  });

  no_messages.forEach((value, key) => {
    total_messages += value;
  });

  users_map.forEach((value, key) => {
    no_users += 1;
  });

  average_messages = total_messages/no_messages.size;
  average_media_per_message /= data.length;
  average_cost /= cost_map.size;

  average_media_per_message =average_media_per_message.toFixed(3);
  average_messages = average_messages.toFixed(1);
  total_cost = -1*total_cost.toFixed(3);
  average_cost = average_cost.toFixed(3);
  
  //Card data
  const count = [
    {
      title: "Unique Users",
      data: no_users,
      addition: "",
      icon: "/images/users.png",
      color: "#FFD700"
    },
    {
      title: "Total Messages Overall",
      data: total_messages,
      addition: "",
      icon: "/images/image_icon.png",
      color: "#FFD700"
    },
    {
      title: "Total Cost",
      data: total_cost,
      addition: "USD",
      icon: "/images/money.png",
      color: "#FFD700"
    },
    
  ];    

  const side_margin = '20px';

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <>
      <div className="Dashboard-page">
      <Layout style={{ minHeight: '100vh' }}>
        <Sidebar location={location}/>
        <Layout>
          <div className="layout-content" style={{ margin: side_margin }}>
            <Row className="rowgap-vbox" gutter={[6, 24]}>
            {count.map((c, index) => (
                <Col
                key={index}
                xs={24}
                sm={24}
                md={24}
                lg={6}
                xl={6}
                className="mb-24"
                >
                <Card bordered={false} className="criclebox " style={{width: "350px" ,height: "150px", backgroundColor: c.color}}>
                    <div className="number">
                    <Row align="middle" justify="center">
                    <Col xs={24} style={{ textAlign: 'center'}}>
                        <Row gutter={[16, 16]}>
                        <img
                            src={process.env.PUBLIC_URL + c.icon}
                            alt="Image Alt Text"
                            style={{ width: '50px', height: '50px', marginRight: '10px', marginTop: "20px"}}
                        />
                        <Title level={1} style={{ marginTop: '20px' , margineRight: "25px", marginBottom: "5px"}}>
                            {c.data} 
                        </Title>
                        
                        <span style={{ fontSize: '13px', color: '#888888', marginTop: '43px', marginBottom: "5px" }}>{c.addition}</span>
                        </Row>
                        <Row>
                        <span style={{ fontSize: '20px', color: '#888888'}}>{c.title}</span>
                        </Row>
                    </Col>
                    </Row>
                    </div>
                </Card>
                </Col>
            ))}

              {/* End of Single Card */}

              </Row>

              {/* Add some margin to create a gap */}
              <div style={{ margin: "20px 0" }}></div>
              
          <Row gutter={[16, 0]}>
              <Col xs={24} sm={24} md={14} lg={14} xl={14}>
              <Card bordered={false} className="criclebox h-full" style={{ width: "100%", alignItems: "left", backgroundColor: "#FFFFFF" }}>
                  <Echart data={data} unique_num={unique_users_map} unique_sess={sessions_map} />
              </Card>
              </Col>

              <Col xs={24} sm={24} md={10} lg={10} xl={10}>
              <Card bordered={false} className="package-card" style={{ width: "100%", height: "400px", alignItems: "right" , backgroundColor: "#FFFFFF"}}>
                  <DoughnutChart data = {data} />
              </Card>
              
              <div style={{marginTop: "16px"}}>
                  <Card bordered={false} className="criclebox h-full" style={{width: "100%", backgroundColor: "#FFFFFF"}}>
                  <LineChart no_messages={no_messages} cost_map={cost_map} unique_num={unique_users_map} unique_sess={sessions_map}/>
                  </Card>
              </div>
              
              </Col>
          </Row>
            </div>

            <div className="chart-vistior" style={{ display: "flex", flexDirection: "row", margin: side_margin, justifyContent: "space-between"}}>
                <Card bordered={false} className="package-card" style={{ width: "100%", alignItems: "right", marginRight: "20px", backgroundColor: "#FFFFFF"}}>
                    <ScrollableTable data = {data} chatbot_contract = {[id, selectedContract]} mainUrl = {mainUrl} pricing_data={customer_pricing_data} company_pricing ={company_pricing_data}/>                
                </Card>
            </div>
            {/* <Content style={{ margin: '16px' }}>{children}</Content> */}
          </Layout>
        </Layout>

        </div>
    </>
  );
}

export default App;

